import React from "react";
import "./SearchFilter.css";
import SearchableDropdown from "../forms/SearchableDropdown";


const FilterPopover = ({
  open,
  fields = [],
  filters = {},
  onChange,
  onReset,
  onClose,
}) => {
  if (!open || fields.length === 0) return null;

  return (
    <div className="zarp-filter-popover" role="dialog" aria-label="Filters">
      <div className="zarp-filter-popover-head">
        <strong>Filters</strong>
        <button type="button" onClick={onReset}>Reset</button>
      </div>
      <div className="zarp-filter-fields">
        {fields.map((field) => {
          const value = filters[field.key] || "";
          return (
            <label key={field.key} className="zarp-filter-field">
              <span>{field.label}</span>
              {field.options?.length ? (
                <SearchableDropdown value={value} onChange={(event) => onChange?.(field.key, event.target.value)}>
                  <option value="">All</option>
                  {field.options.map((option) => (
                    <option key={option.value ?? option} value={option.value ?? option}>
                      {option.label ?? option}
                    </option>
                  ))}
                </SearchableDropdown>
              ) : (
                <input
                  value={value}
                  onChange={(event) => onChange?.(field.key, event.target.value)}
                  placeholder={`Filter by ${field.label.toLowerCase()}`}
                />
              )}
            </label>
          );
        })}
      </div>
      <div className="zarp-filter-popover-foot">
        <button type="button" onClick={onClose}>Done</button>
      </div>
    </div>
  );
};

export default FilterPopover;
